import { toNameCase } from '@flatsy/core/MaterialUi/Typo/Utile'
import i18n from '@flatsy/utils/translations'
import { DateTime } from '@flatsy/utils/dates'
import { ApplicantApplicationState } from 'src/redux/slices/Application'
import { Asset } from '@flatsy/types/Assets'
import { PublicBooking } from '@flatsy/types/Bookings'

const renderDateAndTime = (time: string): string => {
  return toNameCase(i18n.t('@date_at', { value: DateTime.fromISO(time) }))
}

export const asBooking = (applicationState: ApplicantApplicationState): string | false => {
  if (applicationState && applicationState.application.booking) {
    const asBooking = applicationState.application.booking

    if (asBooking && asBooking.start_date && asBooking.start_time) {
      const time = `${asBooking.start_date}T${asBooking.start_time}`
      return renderDateAndTime(time)
    }
  }
  return false
}

export const renderBookingAddress = (
  applicationState: ApplicantApplicationState,
  asset: Asset | undefined
): string => {
  if (applicationState && applicationState.application.booking) {
    const asBooking = applicationState.application.booking

    if (asBooking) {
      return asBooking.asset_address || asset?.address_description || ''
    }
  }
  return asset?.address_description || ''
}

export const renderBookingDate = (booking: PublicBooking | undefined): string | false => {
  if (booking) {
    const time = `${booking.start_date}T${booking.start_time}`
    return renderDateAndTime(time)
  }
  return false
}
